<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="Lbq" name="Lbq">
      <DetailTabData :data="allData.Lbq" :on-change="onChangeDataLb"/>
    </el-tab-pane>
    <el-tab-pane label="Endless" name="Endless">
      <DetailTabData :data="allData.Endless" :on-change="onChangeDataLb"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossGrand" name="RaidbossGrand">
      <DetailTabData :data="allData.RbGrand" :on-change="onChangeDataLb"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossLittle" name="RaidbossLittle">
      <DetailTabData :data="allData.RbLittle" :on-change="onChangeDataLb"/>
    </el-tab-pane>
    <el-tab-pane label="Versus" name="Versus">
      <DetailTabData :data="allData.Versus" :on-change="onChangeDataLb"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import DetailTabData from "./DetailTabData.vue"

function noop() {}

export default {
  name: "event",
  components: {
    DetailTabData,
  },
  props: {
    allData : {},
    onChange: {
      type: Function,
      default: noop
    },
  },
  data: () => {
    return {
      tabActive: "Lbq",
    }
  },
  methods: {
    onChangeDataLb(typeLb) {
      console.log(`tabEdit onChangeDataLb ${typeLb} -> ${this.allData[typeLb].IsActive}`);
    },
  }
};

</script>